import { PositionValidPeriodResponse } from "src/shared/api-types/course";

import request from "./request";

export const getCustomPositionValidPeriods = async (courseId: number) => {
  const json = await request(`/position_valid_periods/custom_courses/${courseId}`);

  return json;
};

/**
 * Resolve a user's position-specific validity override for a course. Only CUSTOM courses support
 * overrides; Moodle/company courses always use the course default, so this resolves to null for
 * them without a request (CREW-538).
 */
export const getUserCourseValidPeriod = async (
  crewId: number,
  userId: number,
  courseId: number,
  isCustom: boolean,
): Promise<PositionValidPeriodResponse | null> => {
  if (!isCustom) {
    return null;
  }
  const response: PositionValidPeriodResponse = await request(
    `/position_valid_periods/custom_courses/${courseId}/crew/${crewId}/user/${userId}`,
  );
  return response;
};
